import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import classnames from 'classnames';

import { Row, Col, Button, DropdownItem, NavItem, Nav, TabPane, NavLink, TabContent } from 'reactstrap';

import styledMagstimTabsWrapper from 'common/controls/StyledMagstimTabsWrapper'
import {
    MagstimHeaderBar,
    MagstimTableClinicalAssessments,
    CurrentLang,
    LocaliseRatingScale,
    MagstimFetch,
    MagstimLoadingSpinner,
    magstim_clickHandler,
    isPDA,
    CurrentTheme,
    GetRange,
    MagstimDropdown,
    MagstimChartSimple,
    MagstimColor
} from "common";

import { REST_CLINICAL_ASSESSMENTS, REST_ENDPOINT_MODEL_CLINICAL_ASSESSMENTS } from 'common/ApiEndpoints';
import * as CsvUtils from 'common/utils/CsvUtils';

const EXPORT_FILE_NAME = 'clinical-assessments.csv'
const DATE_FILTER = 'AssessmentDate'
const RATING_SCALE_FILTER = 'RatingScale'

class ClinicalAssessments extends React.Component {

    state = {
        isLoading: true,
        tableHeight: 'calc(100vh - 410px)',
        chartHeight: 'calc(100vh - 340px)',
        exportFileName: EXPORT_FILE_NAME,
        activeTab: 'tabHistory',
        SelectedClinicalAssessmentItems: undefined,
        UniqueRatingsScales: [],
        Items: [],
        selectedDate: "",
        selectRatingScale: "",
        clinicalAssessmentToDelete:undefined
    };

    constructor() {
        super();

        this._table = React.createRef();
    }

    // eslint-disable-next-line no-unused-vars
    onClickExport = (event) => {
        // console.log('onClickExport');

        if (isPDA()) {
            CsvUtils.downloadAsCSV(document, this.state.exportFileName, this._table.current.getColumns(), this._table.current.getFilteredData());
        }
    }

    onSelectDate = (id) => {
        const range = GetRange(id);
        this.setState({ selectedDate: id })

        this._table.current.addFilter(DATE_FILTER, range);
    }

    onSelectRatingScale = (id) => {

        var filterValue = id;

        if (id === 'All') {
            this._table.current.addFilter(RATING_SCALE_FILTER, '');

            // https://lucidgroup.assembla.com/spaces/magstim/tickets/realtime_list?ticket=1622/
            // On switching tab if All Scales are selected on the table then this.state.SelectedClinicalAssessmentItems remains unpopulated
            // So for the case, populate  with with first scale in the filter, as that's what will be shown
            if (this.state.UniqueRatingsScales.length > 0){
                filterValue = this.state.UniqueRatingsScales[0].RatingScale;   
            }

        } else {
            this._table.current.addFilter(RATING_SCALE_FILTER, id);
        }

        var selectedClinicalAssessmentItems = this.state.Items.filter(function (item) {
            return item[RATING_SCALE_FILTER] === filterValue;
        });

        this.setState({ SelectedClinicalAssessmentItems: selectedClinicalAssessmentItems, selectRatingScale: id });
    }

    onTabItemClick = (tabId) => {
        this.activeKey = tabId;
        this.setState({ activeTab: tabId});
    }


    cellClickCallback = (row, column, cell) => {
        if (column !== undefined && column.property === "delete") {
            this.onDelete(row.ClinicalAssessmentGuid)
        }
    }

    onDelete = (clinicalAssessmentGuid) => {

        this.setState({clinicalAssessmentToDelete:clinicalAssessmentGuid})

        this.props.showModal(CurrentLang().cancel_warning_title,
            CurrentLang().are_you_sure,
            CurrentLang().message_box_yes,
            CurrentLang().message_box_no,
            this.modalCallBack);

    }

    modalCallBack = (result) => {
        if (result === CurrentLang().message_box_yes) {
            this.delete();
        }
    }

    delete = () => {
        console.log('delete',  this.state);
        MagstimFetch.delete(REST_ENDPOINT_MODEL_CLINICAL_ASSESSMENTS, this.state.clinicalAssessmentToDelete)
            .then((data) => {
               this.loadDataFromAPI();
            })
            .catch((error) => {
                this.props.handleError(error);
            });
    }

    getClinicalAssessmentChartData(object) {

        if (object !== undefined && object !== null && object.length > 0) {

            const range = GetRange(this.state.selectedDate); 

            // Grab the chart data so we can filter it
            var chartData = [];
  
            object.forEach(item => {
                chartData.push({AssessmentDate:item.AssessmentDate, RatingScore:item.RatingScore})
            })
        
            // Filter based on date if a date is selected 
            if(range !== null && range !== undefined){
                chartData = chartData.filter(function (item) {
                    return item.AssessmentDate >= range.start && item.AssessmentDate <= range.end;
                });
            }

            var retVal = [
                {
                    yMin: object[0].RatingScaleMinimumScore,
                    yMax: object[0].RatingScaleMaximumScore,
                    xValues: chartData.map(a => a.AssessmentDate),
                    yValues: chartData.map(a => a.RatingScore)
                }
            ];
           
            return retVal;
        }

        return {
            title: CurrentLang().clinical_assessment_rating_score,
            xValues: [],
            yValues: []
        };
    }

    render() {

        console.log('render', this.state.SelectedClinicalAssessmentItems);
        var clinicalAssessmentChartData = []

        if (this.state.activeTab === 'tabGraph') {
            clinicalAssessmentChartData = this.getClinicalAssessmentChartData(this.state.SelectedClinicalAssessmentItems)
        }

        const defaultDropdownItems = [<DropdownItem key="All" id='All'>{CurrentLang().clinical_assessment_all_scales}</DropdownItem>, <DropdownItem key="divider" divider />];

        const ratingScaleChartDropdownItems = defaultDropdownItems.concat(this.state.UniqueRatingsScales.map(e => {
            return <DropdownItem id={e.RatingScale} key={e.RatingScale} value={e.RatingScale}>{e.RatingScale}</DropdownItem>
        }));

        var tabHistory = <>
            <TabPane tabId="tabHistory" className="pl-0" title={CurrentLang().patient_history}>
                <Row className="ui-header">
                    <Col md="6" sm="12" className="header-col">
                        <MagstimHeaderBar  main_title={CurrentLang().clinical_assessments} ShowClose={false} main_icon="fas fa-briefcase-medical">

                        </MagstimHeaderBar>
                    </Col>
                    <Col md="3" sm="12" className="mt-auto mb-auto">
                        <MagstimDropdown id="treatmentDate" onSelect={this.onSelectDate} icon='fas fa-calendar-alt' dropDownKey={this.state.selectedDate}>
                            <DropdownItem key="allTime" id='allTime'>{CurrentLang().treatment_history_date_allTime}</DropdownItem>
                            <DropdownItem key="divider" divider />
                            <DropdownItem key="lastWeeks4" id='lastWeeks4'>{CurrentLang().treatment_history_date_lastWeeks4}</DropdownItem>
                            <DropdownItem key="lastMonths6" id='lastMonths6'>{CurrentLang().treatment_history_date_lastMonths6}</DropdownItem>
                            <DropdownItem key="lastMonths12" id='lastMonths12'>{CurrentLang().treatment_history_date_lastMonths12}</DropdownItem>
                        </MagstimDropdown>
                    </Col>
                    <Col md="3" sm="12" className="mt-auto mb-auto">
                        <MagstimDropdown id="treatmentDate" onSelect={this.onSelectRatingScale} icon='fas fa-briefcase-medical' dropDownKey={this.state.selectRatingScale}>
                            {ratingScaleChartDropdownItems}
                        </MagstimDropdown>
                    </Col>
                </Row>
                <Row className="ui-bg">
                    <Col>
                        <div className="table-area mt-0">
                            <MagstimLoadingSpinner isLoading={this.state.isLoading} />
                            <MagstimTableClinicalAssessments ref={this._table} div_name="idClinicalAssessments" cellClickCallback={this.cellClickCallback} ></MagstimTableClinicalAssessments>
                        </div>
                    </Col>
                </Row>
                <Row className="ui-bg">
                    <Col className="pt-1 pr-4 mt-3 mr-3 mb-3 text-right">
                        <Button color="primary" disabled={this.state.exportDisabled} className="pl-5 pr-5" onClick={this.onClickExport} size={CurrentTheme().ControlSize} ><i className="fas fa-file-excel pr-2"></i> {CurrentLang().table_export_title}</Button>
                    </Col>
                </Row>
            </TabPane>
        </>

        var tabGraph = <>
            <TabPane tabId="tabGraph" className="pl-0" title={CurrentLang().patient_graph}>
                <Row className="ui-header">
                    <Col md="6" sm="12" className="header-col">
                        <MagstimHeaderBar main_title={CurrentLang().clinical_assessment} ShowClose={false} main_icon="fas fa-briefcase-medical">
                        </MagstimHeaderBar>
                    </Col>
                    <Col md="3" sm="12" className="mt-auto mb-auto">
                        <MagstimDropdown id="treatmentDate" onSelect={this.onSelectDate} icon='fas fa-calendar-alt' dropDownKey={this.state.selectedDate}>
                            <DropdownItem key="allTime" id='allTime'>{CurrentLang().treatment_history_date_allTime}</DropdownItem>
                            <DropdownItem key="divider" divider />
                            <DropdownItem key="lastWeeks4" id='lastWeeks4'>{CurrentLang().treatment_history_date_lastWeeks4}</DropdownItem>
                            <DropdownItem key="lastMonths6" id='lastMonths6'>{CurrentLang().treatment_history_date_lastMonths6}</DropdownItem>
                            <DropdownItem key="lastMonths12" id='lastMonths12'>{CurrentLang().treatment_history_date_lastMonths12}</DropdownItem>
                        </MagstimDropdown>
                    </Col>
                    <Col md="3" sm="12" className="mt-auto mb-auto">
                        <MagstimDropdown onSelect={this.onSelectRatingScale} icon='fas fa-briefcase-medical' dropDownKey={this.state.selectRatingScale}>
                            {
                                this.state.UniqueRatingsScales.map(e => {
                                    return <DropdownItem id={e.RatingScale} key={e.RatingScale} value={e.RatingScale}>{e.RatingScale}</DropdownItem>
                                })}
                        </MagstimDropdown>
                    </Col>
                </Row> 
                    <Row className="ui-bg">
                        <Col>
                        <div className="chart-area ui-bg ml-0 mr-0 mb-2 mt-2">
                            <MagstimChartSimple
                                seriesMulti={true}
                                seriesArray={clinicalAssessmentChartData}
                                yMin={clinicalAssessmentChartData.length > 0 ? clinicalAssessmentChartData[0].yMin : 0}
                                yMax={clinicalAssessmentChartData.length > 0 ? clinicalAssessmentChartData[0].yMax : 100}
                                yStepCount={4}
                                height={this.state.chartHeight}
                                noDataMessage={CurrentLang().clinical_assessment_chart_no_data}
                                chartCanvasName="clinicalAssessmentChart"
                            />
                        </div>
                        </Col>
              
                </Row>
            </TabPane>
        </>

        return (
            <Wrapper className="ml-3 mr-3" tableHeight={this.state.tableHeight}>
                <Nav tabs className="border-bottom mb-1">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'tabHistory' })}
                            onClick={() => { this.onTabItemClick('tabHistory'); }}>
                            {CurrentLang().patient_history}
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === 'tabGraph' })}
                            onClick={() => { this.onTabItemClick('tabGraph'); }}>
                            {CurrentLang().patient_graph}
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent className="mt-1 ml-3 mr-3" activeTab={this.state.activeTab} >
                    {tabHistory}
                    {tabGraph}
                </TabContent>
            </Wrapper>
        )
    }

    componentDidMount() {
        this.loadDataFromAPI();
    }

    componentWillUnmount() {
        this.props.setCurrentPatientID("");
    }

    loadDataFromAPI() {
        MagstimFetch.get(`${REST_CLINICAL_ASSESSMENTS}/${this.props.match.params.PatientGuid}`)
            .then((data) => {

                LocaliseRatingScale(data.AllRatingScale);

                this.init(data);

                if ((undefined !== data.patientDetail) && (null !== data.patientDetail)) {
                    var userNameAndID = `${data.patientDetail.FirstName} ${data.patientDetail.LastName} - ${data.patientDetail.PatientIdNum}`;
                    this.setState({ exportFileName: `${userNameAndID}-${EXPORT_FILE_NAME}` })
                    this.props.setCurrentPatientID(userNameAndID);
                }
            })
            .catch((error) => {
                this.handleError(error);
            }).finally(() => {
                this.setState({ isLoading: false });
            });
    }

    init(data) {
        if (data !== undefined && data !== null && data.items !== undefined && data.items !== null) {

            if (this._table && this._table.current) {
                this._table.current.initForSelect(data.items);
                this._table.current.resetFilters();
            }

            var uniqueRatingsScales = data.items.filter((e, i) => data.items.findIndex(a => a['RatingScale'] === e['RatingScale']) === i);
            var selectedClinicalAssessmentItems = undefined;

            // #MAGS-1426 - PDM - Clinical Assessment. Scale Filter fails on deletion of assessment 
            // re apply any filters if they are set
            if (this._table && this._table.current) {
             
                if(this.state.selectedDate !== undefined && this.state.selectedDate.length > 0){
                    this.onSelectDate(this.state.selectedDate);
                }

                if(this.state.selectRatingScale !== undefined && this.state.selectRatingScale.length > 0){
                    // Check we still have this scale type
                    var ratingScaleToFilter = 'All';

                    uniqueRatingsScales.forEach (e => {
                        if(e.RatingScale === this.state.selectRatingScale){
                            ratingScaleToFilter = e.RatingScale
                        }
                    });

                    this.onSelectRatingScale(ratingScaleToFilter);
                }
            }   

            if (uniqueRatingsScales.length > 0)

                // #MAGS-1774 - PDM - Clinical Assessments Graph appears wrong after deleting an assessment
                // If we are reloading data after a delete - make sure we update the chart with the selected scale, not just the first one
                var  selectRatingScale = uniqueRatingsScales[0].RatingScale;

                if(this.state.selectRatingScale.length !== 0){
                    selectRatingScale = this.state.selectRatingScale;
                }

                selectedClinicalAssessmentItems = data.items.filter(function (event) {
                    return event[RATING_SCALE_FILTER] === selectRatingScale;
            });

            this.setState({ UniqueRatingsScales: uniqueRatingsScales, Items: data.items, SelectedClinicalAssessmentItems: selectedClinicalAssessmentItems });
        }
    }

    handleError(error) {
        console.log(error);
        if (this.props.handleError !== undefined) {
            this.props.handleError(error);
        }

        if (isPDA() === false) {
            magstim_clickHandler('error', error);
        }
    }
}

const Wrapper = styled(styledMagstimTabsWrapper)`

.ui-header{
    color: ${MagstimColor.MagstimGroupHeaderText};
    background-color: ${MagstimColor.MagstimCardHeaderBackground};
}

.header-col{
    padding-left:0px;
}


`

export default isPDA() ? withRouter(ClinicalAssessments) : ClinicalAssessments;